export default "__VITE_ASSET__DApXVUgw__"